<kendo-card style="width: 100%; padding-bottom: 0px;">
	<!-- does not work in css -->
	<kendo-card-header>
		<div class="row">
			<div class="col col-4">
				<img src="../../assets/images/logo.png" alt="logo" class="logo">
			</div>
			<div class="col col-4 projInfo">
				<span>{{ customerName }}</span>
			</div>
			<div class="col col-4">
				<div kendoTooltip [tooltipTemplate]="photo" filter="span" style="text-align: right; margin-right: 20px;">
					<span class="prop-desc">{{ projectService.template.productName }}</span>
				</div>
				<ng-template #photo>
					<img *ngIf="projectService.template.productPhoto" [src]="projectService.template.productPhoto" style="max-width: 200px;" />
				</ng-template>
			</div>
		</div>													
	</kendo-card-header>
</kendo-card>

<kendo-splitter orientation="vertical" id="temporary-alert-zone" style="max-height: 100vh">
	<kendo-splitter-pane>
		<kendo-splitter [ngClass]="[toolBSrvc.iconClass('None','None')]">

			<kendo-splitter-pane [collapsible]="true" [size]="splitterSize('panelLeft')" class="left-splitter-pane" (collapsedChange)="onSplitterExpand('panelLeft', $event)" (sizeChange)="onSplitterResize('panelLeft', $event)"
				[collapsed]="!isPanelExpanded('panelLeft')">
				<div>
					<app-toolbox [optionMode]="selectedView === 'Options'"></app-toolbox>
				</div>


				<div kendoTooltop class="user">
					<button 
						kendoButton class="executive-btns k-rounded-md" [svgIcon]="projectService.svgIcons.userIcon" (click)="authService.logout()">
					</button>
					<span>{{ userName }}</span>
				</div>


				<div *ngIf="projectService.sysInfo" class="version">
					Designer <b>v. {{ projectService.sysInfo.version }}</b>
					<br>
					<span *ngIf="env">Environment <b>{{ env }}</b><br></span>					
					Configuration <b (click)="showVersionDetails = !showVersionDetails"
						[ngClass]="{'span-click': true, 'span-errors': projectService.template.errors?.length > 0}"
						>v. {{ projectService.template.version }} {{ projectService.template.isDraft ? 'draft': '' }}</b>

					<span class="md5" *ngIf="showVersionDetails">
						<br>ID: {{ projectService.template.productId }}
					</span>
					<div class="config-errors" *ngIf="showVersionDetails && projectService.template.errors?.length > 0">
						<br>
						Errors:
						<ul>
							<li *ngFor="let d of projectService.template.errors">{{ d }}</li>
						</ul>
					</div>

					<div *ngIf="projectService.isSupervisor">
						<span *ngIf="!projectService.showDebugInfo" (click)="projectService.showDebugInfo = true" class="span-click">Show technical details</span>
						<span *ngIf="projectService.showDebugInfo" (click)="projectService.showDebugInfo = false" class="span-click">Hide technical details</span>
					</div>
				</div>
			</kendo-splitter-pane>

			<kendo-splitter-pane class="center-splitter-pane">
				<kendo-splitter orientation="vertical" style="width: 100%;" #mainSvg>
					<kendo-splitter-pane size="125px" [scrollable]="false" [collapsible]="true" [resizable]="true" #topSplit>
						<app-areas (areaClick)="onAreaClick($event)" (zoomClick)="onZoomClick($event)" (waitVisible)="onWaitChange($event)"
							(undoClick)="onUndoClick($event)" (redoClick)="onRedoClick()" (resetClick)="onResetClick()" (rewindClick)="onUndoClick($event)"
							[priceValue]="currentPrice" [showPrice]="crmPresent" [undoDisabled]="undoDisabled" [redoDisabled]="redoDisabled"
							(viewChange)="onViewChange($event)"></app-areas>
					</kendo-splitter-pane>

					<kendo-splitter-pane [scrollable]="true" id="mainPane">
						<app-svg [setSelectedItems]="setSelectedItems" [zoom]="currentZoom" *ngIf="selectedView === 'Design'"></app-svg>
						<app-extras-options *ngIf="selectedView === 'Options'"></app-extras-options>
					</kendo-splitter-pane>

				</kendo-splitter>
			</kendo-splitter-pane>

			<kendo-splitter-pane [collapsible]="true" [size]="splitterSize('panelRight')" [scrollable]="true" (collapsedChange)="onSplitterExpand('panelRight', $event)" (sizeChange)="onSplitterResize('panelRight', $event)"
				[collapsed]="!isPanelExpanded('panelRight')">
				<kendo-card style="width: 100%">
					<kendo-card-body>
						<kendo-tabstrip [keepTabContent]="true">
							<kendo-tabstrip-tab i18n-title="Main tabs|'Properties' card title" title="Properties" [selected]="true">
								<ng-template kendoTabContent>
									<app-project-details></app-project-details>
									<div>
										<kendo-card-header>
											<span i18n="Cards|Element properties card title">Element properties</span> <span *ngIf="currentElement != ''">: {{ currentElement }}</span>
										</kendo-card-header>
										<kendo-card-body>
											<app-card></app-card>
										</kendo-card-body>
									</div>
								</ng-template>
							</kendo-tabstrip-tab>

							<kendo-tabstrip-tab i18n-title="Main tabs|'Statics' card title" title="Statics">
								<ng-template kendoTabContent>
									<div class="row" *ngIf="canDisableStatics">
										<div class="col col-4">
											<span>Use statics</span>:
										</div>
										<div class="col col-8">
											<input type="checkbox" kendoCheckBox size="large" style="width: 20px; height: 20px; margin: 5px"
												[(ngModel)]="useStatics" [disabled]="projectService.getLockStatusOfProjProp()" />
										</div>
									</div>

									<div class="row">
										<div class="col col-4">
											<span i18n="Common|Weight">Weight</span>:
										</div>
										<div class="col col-8">
											<app-numeric-textbox [value]="projectService.projectWeight" [disabled]="true"></app-numeric-textbox> kg
										</div>
									</div>

									<app-statics></app-statics>
								</ng-template>
							</kendo-tabstrip-tab>

							<kendo-tabstrip-tab i18n-title="Main tabs|'Other' card title" title="Other">
								<ng-template kendoTabContent>
									<kendo-panelbar #panelCutting (stateChange)="onPanelChange('panelCutting', $event)">
										<kendo-panelbar-item i18n-title="Cards|Cutting on site card title" title="Cutting on site" [selected]="true" [expanded]="isPanelExpanded('panelCutting')">
											<ng-template kendoPanelBarContent>
												<kendo-card style="width: 100%">
													<kendo-card-body>
														<app-specification [mode]="'CuttingOnSite'"></app-specification>
													</kendo-card-body>
												</kendo-card>
											</ng-template>
										</kendo-panelbar-item>
									</kendo-panelbar>
								</ng-template>
							</kendo-tabstrip-tab>
						</kendo-tabstrip>
					</kendo-card-body>
				</kendo-card>

			</kendo-splitter-pane>

		</kendo-splitter>

	</kendo-splitter-pane>
</kendo-splitter>

<app-wizard></app-wizard>

<app-migration-report-dialog [migrationResult]="migrationResult" (forceOpen)="forceOpen()">
</app-migration-report-dialog>

<app-error-dialog></app-error-dialog>

<app-info-dialog [dialogOpened]="infoOpened" [dialogMessage]="infoMessage"
	(dialogClosed)="onInfoClosed()"></app-info-dialog>

<app-wait [show]="showWait"></app-wait>
